/**
 * @desc 上传文件至OSS
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(params: Params): Promise<defs.StandardReturn<string>> {
  return defHttp.post({
    url: '/oss/upload',
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<string>> {
  return defHttp.post({
    url: '/mock/oss/upload',
  });
}
